<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Kas Mutasi</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Cabang Asal">
                        <div>
                            <multiselect
                                name="dariCabang"
                                v-model="input.cabangAwalKasMutasi" 
                                :options="cabangAwalOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang Tujuan --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Cabang Tujuan">
                        <div>
                            <multiselect
                                name="dariCabang"
                                v-model="input.cabangTujuanKasMutasi" 
                                :options="cabangTujuanOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang Tujuan --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Nominal">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalKasMutasi" name="nominalKasMutasi" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Keterangan">
                        <b-form-textarea v-model="input.keteranganKasMutasi" name="keteranganKasMutasi"></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="kasMutasiSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Kas Mutasi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas mutasi ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-kas-mutasi',
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input: {
                cabangAwalKasMutasi: null,
                cabangTujuanKasMutasi: null,
                nominalKasMutasi: null,
                keteranganKasMutasi: ""
            },
            cabangAwalOption: [],
            cabangTujuanOption: [],
            srcCabangId: -1
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.cabangAwalOption = this.$helper.getAllCabang()

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangTujuanOption.push(element)
                })
            })

            Promise.all([getCabang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
            
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            let payload = new FormData()
            let nominalKasMutasi = this.$helper.removeThousandSeparator(this.input.nominalKasMutasi);

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("cabangSrcId", this.input.cabangAwalKasMutasi.id)
            payload.append("cabangDestId", this.input.cabangTujuanKasMutasi.id)
            payload.append("nominal", nominalKasMutasi)
            payload.append("keterangan", this.input.keteranganKasMutasi)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/cabang_cabang/input", payload).then(() => {
                this.$helper.setFlash(`Input kas mutasi baru berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){

            if(this.input.cabangAwalKasMutasi == null){
                this.$helper.toastErr(this, "Cabang Dari tidak boleh kosong!")
            }else if(this.input.cabangTujuanKasMutasi == null){
                this.$helper.toastErr(this, "Cabang Tujuan tidak boleh kosong!")
            }else if(this.input.cabangAwalKasMutasi.id == this.input.cabangTujuanKasMutasi.id) {
                this.$helper.toastErr(this, "Cabang Dari tidak boleh sama dengan Cabang Tujuan")
            }else {
                this.$bvModal.show("modal-confirm-input")
            }
            
        }
    },

    watch: {
        "input.nominalKasMutasi": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalKasMutasi = result);
        },
    },

    created(){
        this.init()
    }
}
</script>
